import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonList, PageHeader, ReportModal, ReportTemplateCard, BigButton, Button } from "../../../Components";
import { colors, css, fonts, frames, mediaQueriesNumbers, useMediaQuery } from "../../../Styles";

import { TestData as ReportTemplatesData } from "../../../Assets/TestData/reportTemplates";
import { ButtonTypes, ListStyle_Types } from "../../../Definitions";

export default function Reports() {
  const {t} = useTranslation()
  const [templateMode, setTemplateMode] = useState<boolean>(false) 
  const [reportModal, setReportModal] = useState(false)
  const [copyTemplateMode, setCopyTemplateMode] = useState(false)
  const [selectedReport, setSelectedReport] = useState<number|undefined>(undefined)
  const hideBtnText = useMediaQuery(`(max-width: 450px)`);
  const hideBtns = useMediaQuery(`(max-width: 600px)`);
  // const pageHeaderResponsive = useMediaQuery(`(max-width: ${mediaQueriesNumbers.pageHeaderResponsive2elementsMax}px)`);

  // Handle ReportTemplateCard select
  const handleReportSelect = (id:number) => {
    setSelectedReport(id) // set report id
    copyTemplateMode 
      ? copyTemplateFlow() // if in copy template mode, start copy template flow on report select
      : setReportModal(true) // else open report modal on report select
  }

  // Handle report modal close
  const handleCloseBtn = () => {
    setReportModal(false) // Close report modal
    setSelectedReport(undefined) // Reset selected report
    if (templateMode) {
      setTemplateMode(false); // If modal is "newTemplate === true" then set it to false
    }
  }

  // Copy template flow
  const copyTemplateFlow = () => {
    setReportModal(true); // Open report modal
    setTemplateMode(true); // Set modal prop "newTemplate === true"
    setCopyTemplateMode(false) // Remove bg overlay
  }

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between"}}>
          <PageHeader topHeader={t("reports.report")} subHeader={t("overview")}/>
          <div style={{display: "block", zIndex: "99999"}}>
            <ButtonList 
              contents={copyTemplateMode ? [t("buttons.cancelBtn")] : [t("reports.addTemplate"), t("reports.copyTemplate")]} 
              onClick={copyTemplateMode 
                ? (i => { 
                    if (i === 0) {setCopyTemplateMode(false)}
                  })
                : (i => { 
                  if (i === 0) {setTemplateMode(true); setReportModal(true)}
                  else if (i === 1) {setCopyTemplateMode(true)}
                })
              }
              buttonType={ButtonTypes.primaryButton}
              overrides={{
                baseButton: { ...( !hideBtns ? {...css.button_FitContent, minWidth: "none"} : {backgroundColor: colors.greyDarkSecondary})}
              }}
              listOverrides={{
                listStyle: !hideBtns ? ListStyle_Types.horizontal : ListStyle_Types.vertical,
              }}
              responsiveOverrides={{
                isResponsive: !hideBtns ? false : true,
                popoverStyle: { backgroundColor: colors.greyDarkPrimary, padding: "20px", borderRadius: "10px", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d" },
                openContent: hideBtnText ? "" : "Options"
              }}
            />
          </div>
        </div>
      </frames._page_inner_header>
      <frames._page_inner_content>
        {/* Wrap of Reports Cards */}
        <frames._page_inner_content_scroll>
          <frames.CardsColumnCount>
            {/* Create Report Btn */}
            <Button 
              content={t("buttons.createBtn")+" "+t("reports.report")} 
              subContent={t("reports.createNewReport")} 
              onClick={() => setReportModal(true)}
              buttonType={ButtonTypes.cardButton}
            />
            {/* Backdrop filter */}
            {copyTemplateMode
            ? <div style={{...css.backdropFilter, zIndex: "9999"}}/>
            : undefined }
            {/* Report Templates */}
            <div style={{zIndex: copyTemplateMode? "99999" : "auto", position: copyTemplateMode? "relative" : "unset"}}>
              {ReportTemplatesData.map((report) => (
                <ReportTemplateCard key={report.reportTemplateNo} reportId={report.reportTemplateNo} onReportSelect={handleReportSelect}/>
              ))}
            </div>
          </frames.CardsColumnCount>
        </frames._page_inner_content_scroll>
      </frames._page_inner_content>

      <ReportModal 
        isModalOpen={reportModal} 
        closeModal={handleCloseBtn} 
        report={selectedReport ? ReportTemplatesData.find(report => report.reportTemplateNo === selectedReport) : undefined }
        newTemplate={templateMode ? true : false}
      />

    </frames.Page_inner>
  )
}